document.addEventListener('DOMContentLoaded', function() {
  const thumbs = new Swiper('.pm-0002-gallery-offers-slider-thumbs', {
    spaceBetween: 15,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      320: {
        slidesPerView: 4.5,
      },
      640: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 5,
      },
      1024: {
        slidesPerView: 6,
      },
    }
  });

  const main = new Swiper('.pm-0002-gallery-offers-slider-main', {
    spaceBetween: 10,
    thumbs: {
      swiper: thumbs,
    },
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  const allSelectableBoxes = document.querySelectorAll('.pm-0002-gallery-offers-offer-box, .pm-0002-gallery-offers-bestseller-box');
  const defaultSelectedId = '12er';

  // Sticky CTA elements
  const stickyCta = document.querySelector('.pm-0002-sticky-cta-mobile');
  const stickyCtaTitle = stickyCta ? stickyCta.querySelector('.pm-0002-sticky-cta-title') : null;

  // Identify the trigger section for sticky CTA
  const triggerSection = document.querySelector('.pm-0002-gallery-offers-bestseller-box');

  //Main Button
  const button = document.querySelector('.pm-0002-gallery-offers-main-button');
  const stickyButton = document.querySelector('.pm-0002-sticky-cta-button');
  const stickyContent = document.querySelector('.pm-0002-sticky-cta-price');
  const stickyTitle = document.querySelector('.pm-0002-sticky-cta-title');
  const stickyDesktopTitle = document.querySelector('.pm-0002-sticky-cta-title-desktop');

  function selectBox(selectedBox) {
    allSelectableBoxes.forEach(box => box.classList.remove('is-selected'));

    //Add Class
    selectedBox.classList.add('is-selected');

    //Update normal add to cart
    const { url, buttonText, content, title, desktopTitle } = selectedBox.dataset;
    button.href = url;
    button.innerText = buttonText;

    //Update sticky add to cart with more data
    stickyButton.innerText = buttonText;
    stickyButton.href = url;
    stickyContent.innerHTML = content;
    stickyTitle.innerText = title;
    stickyDesktopTitle.innerText = desktopTitle;
  }

  allSelectableBoxes.forEach(box => {
    box.addEventListener('click', () => {
      selectBox(box);
    });
  });

  const defaultBox = document.querySelector(`.pm-0002-gallery-offers-offer-box[data-offer-id="${defaultSelectedId}"]`) || document.querySelector(`.pm-0002-gallery-offers-bestseller-box[data-offer-id="bestseller"]`);
  if (defaultBox) {
    selectBox(defaultBox);
  }

  // Sticky CTA scroll logic
  function handleScroll() {
    if (triggerSection && stickyCta) {
      const triggerSectionRect = triggerSection.getBoundingClientRect();
      // Show sticky CTA when the bottom of the trigger section is no longer visible
      const isScrolledPastSection = triggerSectionRect.bottom < 0; 

      if (isScrolledPastSection) {
        stickyCta.classList.add('is-visible');
      } else {
        stickyCta.classList.remove('is-visible');
      }
    } else {
      // Hide sticky CTA on desktop or if elements don't exist
      if (stickyCta) {
          stickyCta.classList.remove('is-visible');
      }
    }
  }

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);
  handleScroll();
});